/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneIcon from 'base/components/standalone/Icon';

export const DynamicStandaloneIcon = StandaloneIcon;
export type DynamicStandaloneIconProps = PropsFromComponent<typeof StandaloneIcon>;

export const DynamicStandaloneIconWith = (extras: DynamicStandaloneExtras): typeof StandaloneIcon => {
    return function DynamicStandaloneIcon(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Icon');
        return <StandaloneIcon {...mergeProps({ options: { theme } }, props)} />;
    }
}